<template>
  <div class="project-settings">
    <div class="modal-body">
      <div class="project-settings__heading">
        <div class="project-settings__name">
          <input type="text" v-model="projectName" @change="renameProject" />
          <ui-icon name="edit" />
        </div>
      </div>

      <div
        class="project-settings__endpoints"
        v-if="project.endpoints.length > 0"
      >
        <h5>Form's Settings:</h5>

        <project-endpoint
          v-for="endpoint in project.endpoints"
          :key="endpoint.id"
          :endpoint="endpoint"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-sm btn-primary"
        @click="createForm"
        :disabled="project.archive === 1"
      >
        Create Form
      </button>
      <div
        class="btn btn-sm btn-danger"
        @click="archiveProject"
        v-if="project.archive === 0"
      >
        Move to Archive
      </div>
      <div
        class="btn btn-sm btn-info"
        @click="unarchiveProject"
        v-if="project.archive === 1"
      >
        Restore from Archive
      </div>
    </div>
  </div>
</template>

<script>
import API from '../../../api'
import UiHeader from '../ui-kit/ui-header.vue'
import UiIcon from '../ui-kit/ui-icon.vue'
import ProjectEndpoint from './project-endpoint.vue'
export default {
  name: 'project-settings',
  components: { UiHeader, UiIcon, ProjectEndpoint },
  props: {
    project: Object
  },
  data() {
    return {
      projectName: this.project.name
    }
  },
  methods: {
    async createForm() {
      this.$root.$emit('create-form', {
        projectName: this.projectName,
        project: this.project
      })
    },
    async renameProject() {
      try {
        await API.projects.update({
          projectId: this.project.id,
          projectName: this.projectName
        })
        this.$store.commit('renameProject', {
          id: this.project.id,
          name: this.projectName
        })
      } catch (err) {
        console.error(err)
      }
    },
    async archiveProject() {
      try {
        const response = await API.projects.remove({
          projectId: this.project.id
        })
        if (!response.error) {
          this.$store.commit('changeArchiveState', {
            id: this.project.id,
            archive: 1
          })
        }
      } catch (err) {
        console.error(err)
      }
    },
    async unarchiveProject() {
      try {
        const response = await API.projects.restore({
          projectId: this.project.id
        })
        if (!response.error) {
          this.$store.commit('changeArchiveState', {
            id: this.project.id,
            archive: 0
          })
        }
      } catch (err) {
        console.error(err)
      }
    }
  },
  watch: {
    project() {
      this.projectName = this.project.name
    }
  }
}
</script>

<style lang="scss">
.project-settings {
  &__heading {
    display: flex;
    align-items: center;
    .btn {
      display: flex;
      align-items: center;
      margin-right: 1rem;
      .ui-icon {
        margin-right: 4px;
      }
    }
  }
  &__name {
    position: relative;
    flex-grow: 1;
    input {
      display: block;
      width: 100%;
      padding: 8px 8px 8px 32px;
      font-weight: bold;
      font-size: 16px;
      line-height: normal;
      background-color: transparent;
      border: 0;
      border-radius: $border-radius-sm;
      outline: none;
      box-shadow: 0 0 0 2px $gray-300;
      cursor: pointer;
      transition: 0.2s;
      &:hover {
        box-shadow: 0 0 0 2px $gray-400;
      }
      &:focus {
        box-shadow: 0 0 0 2px $blue;
      }
    }
    .ui-icon {
      position: absolute;
      top: 50%;
      left: 0.5em;
      z-index: 1;
      color: $gray-500;
      transform: translateY(-50%);
      pointer-events: none;
    }
  }
  &__endpoints {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% + 10px);
    margin-top: 1rem;
    margin-right: -5px;
    margin-left: -5px;
    h5 {
      width: 100%;
    }
    & > * {
      margin: 5px 5px;
    }
  }
  &__actions {
    display: flex;
    flex-wrap: wrap;
    & > * {
      margin-top: 1rem;
      margin-right: 1rem;
    }
  }
}
</style>
